/*365플러스 컬러별 색상 확인 슬라이드*/
const slideContainer = document.getElementById('slideContainer');
const progressBar = document.getElementById('progressBar');
const selectedColorDisplay = document.getElementById('selectedColor');

// ✅ background-image URL 방식으로 수정
const colorMap = {
  beige: {
    bg: 'url(https://cdn.shopify.com/s/files/1/0485/0486/4929/files/anayo-beige.jpg)',
    name: ' ベージュ'
  },
  gray: {
    bg: 'url(https://cdn.shopify.com/s/files/1/0485/0486/4929/files/anayo-gray.jpg)',
    name: ' グレー'
  },
  mint: {
    bg: 'url(https://cdn.shopify.com/s/files/1/0485/0486/4929/files/anayo-mint.jpg)',
    name: ' ミント'
  },
  khaki: {
    bg: 'url(https://cdn.shopify.com/s/files/1/0485/0486/4929/files/anayo-khaki.jpg)',
    name: ' カーキ'
  },
  bk: {
    bg: 'url(https://cdn.shopify.com/s/files/1/0485/0486/4929/files/anayo-black.jpg)',
    name: ' ブラック'
  },
  zebra: {
    bg: 'url(https://cdn.shopify.com/s/files/1/0485/0486/4929/files/zebra_2c186bb6-337e-4276-900f-32f1196e5ce5.jpg)',
    name: ' ゼブラ'
  },
  bleo: {
    bg: 'url(https://cdn.shopify.com/s/files/1/0485/0486/4929/files/brown-leopard_d51a4ff1-4eeb-41ce-8ebe-fc425132fab7.jpg)',
    name: ' ブラウンレオパード'
  },
  gleo: {
    bg: 'url(https://cdn.shopify.com/s/files/1/0485/0486/4929/files/gray-leopard_dabcaa90-d935-4442-89f1-781b4c9ec972.jpg)',
    name: ' グレー レオパード'
  }
};

let swiper;

function loadSlides(color) {

  if (!slideContainer) return;

  slideContainer.innerHTML = '';
  for (let i = 1; i <= 6; i++) {
    const slide = document.createElement('div');
    slide.classList.add('swiper-slide');
    const padded = String(i).padStart(2, '0');
    slide.innerHTML = `<img src="https://gooseket.com/web/upload/product_detail/365plus/colorchip/365plus_${color}${padded}.jpg" alt="${color}-${i}">`;
    slideContainer.appendChild(slide);
  }
  if (swiper) swiper.destroy(true, true);
  swiper = new Swiper('.colorSwiper', {
    loop: false,
    slidesPerView: 1.5,
    spaceBetween: 10,
    grabCursor: true,
    allowTouchMove: true,
    on: {
      slideChange: () => {
        const total = swiper.slides.length;
        const progress = ((swiper.realIndex + 1) / total) * 100;
        if (progressBar) progressBar.style.width = progress + '%';
      }
    }
  });
  if (progressBar) progressBar.style.width = '16.6%';
}

document.querySelectorAll('.color-circle').forEach(el => {
  const color = el.getAttribute('data-color');
  const colorInfo = colorMap[color];
  if (colorInfo) {
    el.style.backgroundImage = colorInfo.bg;
    el.style.backgroundSize = 'cover';
    el.style.backgroundPosition = 'center';
  }

  el.addEventListener('click', () => {
    document.querySelector('.color-circle.active')?.classList.remove('active');
    el.classList.add('active');

    loadSlides(color);

    if (selectedColorDisplay && colorInfo) selectedColorDisplay.innerHTML = `
      <div class="chip" style="background-image:${colorInfo.bg}; background-size:cover;"></div>
      <span>${colorInfo.name}</span>
    `;
  });
});

document.addEventListener('DOMContentLoaded', () => {
  if (slideContainer) loadSlides('bk');
});


/*구석구석 섬세한 - 하단 통합 초기화에서 처리 */

/*어디든 착_핸디백/힙색/유모차가방/무한한활용도_365슬링백*/

 document.addEventListener('DOMContentLoaded', function () {
    const swiper = new Swiper('.customSingleSlideSwiper2', {
      slidesPerView: 1,
      spaceBetween: 10,
      grabCursor: true,
      loop: false,
      on: {
        init: function () {
          updateProgressBar(this);
        },
        slideChange: function () {
          updateProgressBar(this);
        }
      }
    });

    function updateProgressBar(swiperInstance) {
      const totalSlides = swiperInstance.slides.length;
      const percent = ((swiperInstance.activeIndex + 1) / totalSlides) * 100;
      const bar = document.getElementById('progressBarSliderOnly');
      if (bar) bar.style.width = percent + '%';
    }
  });



/*슬링백상단누끼슬라이드*/

 const chips = document.querySelectorAll('.color-circle');
    const image = document.getElementById('mainImage');
    const chipDisplay = document.querySelector('#selectedColor .chip');
    const nameDisplay = document.querySelector('#selectedColor span');

    chips.forEach(chip => {
      chip.addEventListener('click', () => {
        chips.forEach(c => c.classList.remove('active'));
        chip.classList.add('active');

        const imgSrc = chip.getAttribute('data-img');
        const colorHex = chip.getAttribute('data-hex');
        const colorName = chip.getAttribute('data-name');

        image.src = imgSrc;
        chipDisplay.style.background = colorHex;
        nameDisplay.textContent = colorName;
      });
    });


/*슬링백 누끼 컬러칩 탭메뉴_365슬링백*/

const chipsTop = document.querySelectorAll('.color-circle-top');
const imageTop = document.getElementById('mainImageTop');
const chipDisplayTop = document.querySelector('#selectedColorTop .chip-top');
const nameDisplayTop = document.querySelector('#selectedColorTop span');

chipsTop.forEach(chip => {
  chip.addEventListener('click', () => {
    chipsTop.forEach(c => c.classList.remove('active'));
    chip.classList.add('active');

    const imgSrc = chip.getAttribute('data-img');
    const colorHex = chip.getAttribute('data-hex');
    const colorName = chip.getAttribute('data-name');

    imageTop.src = imgSrc;
    chipDisplayTop.style.background = colorHex;
    nameDisplayTop.textContent = colorName;
  });
});

/* 컬러 착용샷 슬라이드 - 하단 통합 초기화에서 처리 */

/* 아코디언 - 하단 이벤트 위임 방식으로 처리 */


/*비디오태그 재생*/
   document.addEventListener('DOMContentLoaded', () => {
    setTimeout(() => {
      document.querySelectorAll('video').forEach(video => {
        if (video.offsetParent !== null) {
          video.play().catch(() => {});
        }
      });
    }, 300);
  });
  
    


/* AIR 슬라이드 - 하단 통합 초기화에서 처리 */

/* =========================================================
   공통 상세페이지 Swiper 통합 초기화 / 재초기화
   - 365 PLUS + 워머 상세 공용
   - 새 테마가 상세 DOM을 다시 렌더링해도 자동 복구
   - 각 슬라이드는 자기 클래스 기준으로 독립 처리
========================================================= */
(function () {
  let observer = null;
  let timer = null;
  let retry = 0;
  const MAX_RETRY = 50;

  function swiperReady() {
    return typeof window.Swiper === 'function';
  }

  function isInitialized(el) {
    return !!(el && (el.swiper || el.classList.contains('swiper-initialized')));
  }

  function safeUpdate(el) {
    if (el && el.swiper) {
      try { el.swiper.update(); } catch (e) {}
    }
  }

  /* ---------------------------------------------------------
     1) structure-swiper
  --------------------------------------------------------- */
  function initStructureSwipers() {
    document.querySelectorAll('.structure-swiper').forEach((el) => {
      if (isInitialized(el)) {
        safeUpdate(el);
        return;
      }

      new Swiper(el, {
        slidesPerView: 1.5,
        spaceBetween: 20,
        grabCursor: true,
        allowTouchMove: true,
        loop: false,
        centeredSlides: false,
        slidesOffsetAfter: 40,
        observer: true,
        observeParents: true,
        resizeObserver: true
      });
    });
  }

  /* ---------------------------------------------------------
     2) 365 PLUS colorSwiper
     - data-color가 없어도 순서(index)로 동작
  --------------------------------------------------------- */
  function updateColorSwiperProgress(index, swiper) {
    const progressEls = document.querySelectorAll('.progress-bar-container');
    const progressEl = progressEls[index];
    const bar = progressEl?.querySelector('.progress-bar-fill');

    if (!bar || !swiper) return;

    const total = swiper.slides ? swiper.slides.length : 0;

    if (total <= 1) {
      bar.style.width = '100%';
      return;
    }

    const visible = typeof swiper.params.slidesPerView === 'number'
      ? swiper.params.slidesPerView
      : 1;

    const maxIndex = Math.max(1, Math.ceil(total - visible));
    const current = Math.min(swiper.activeIndex || 0, maxIndex);

    bar.style.width =
      (((current + 1) / (maxIndex + 1)) * 100) + '%';
  }

  function ensureColorSwiper(index) {
    const swiperEls = document.querySelectorAll('.swiper.colorSwiper');
    const swiperEl = swiperEls[index];

    if (!swiperEl) return null;

    if (swiperEl.swiper) {
      swiperEl.swiper.update();
      updateColorSwiperProgress(index, swiperEl.swiper);
      return swiperEl.swiper;
    }

    const instance = new Swiper(swiperEl, {
      slidesPerView: 1.5,
      spaceBetween: 10,
      centeredSlides: false,
      grabCursor: true,
      allowTouchMove: true,
      loop: false,
      observer: true,
      observeParents: true,
      resizeObserver: true,
      on: {
        init(swiper) {
          updateColorSwiperProgress(index, swiper);
        },
        slideChange(swiper) {
          updateColorSwiperProgress(index, swiper);
        },
        resize(swiper) {
          updateColorSwiperProgress(index, swiper);
        }
      }
    });

    updateColorSwiperProgress(index, instance);
    return instance;
  }

  function showColorSwiperByIndex(selectedIndex) {
    const chips = Array.from(document.querySelectorAll('.color-chip'));
    const swiperEls = Array.from(document.querySelectorAll('.swiper.colorSwiper'));
    const progressEls = Array.from(document.querySelectorAll('.progress-bar-container'));

    if (!swiperEls.length) return;

    chips.forEach((chip, index) => {
      chip.classList.toggle('active', index === selectedIndex);
    });

    swiperEls.forEach((swiperEl, index) => {
      swiperEl.style.display = index === selectedIndex ? 'block' : 'none';
    });

    progressEls.forEach((progressEl, index) => {
      progressEl.style.display = index === selectedIndex ? 'block' : 'none';
    });

    requestAnimationFrame(() => {
      const instance = ensureColorSwiper(selectedIndex);
      if (!instance) return;

      instance.update();

      if (instance.activeIndex !== 0) {
        instance.slideTo(0, 0);
      }

      updateColorSwiperProgress(selectedIndex, instance);
    });
  }

  function bindColorSwiperChips() {
    const chips = Array.from(document.querySelectorAll('.color-chip'));
    const swiperEls = Array.from(document.querySelectorAll('.swiper.colorSwiper'));

    if (!chips.length || !swiperEls.length) return;

    chips.forEach((chip, index) => {
      if (chip.dataset.detailBoundColorSwiper === '1') return;
      chip.dataset.detailBoundColorSwiper = '1';

      chip.addEventListener('click', () => {
        showColorSwiperByIndex(index);
      });
    });

    let activeIndex = chips.findIndex(
      (chip) => chip.classList.contains('active')
    );
    if (activeIndex < 0) activeIndex = 0;

    showColorSwiperByIndex(activeIndex);
  }

  /* ---------------------------------------------------------
     3) customSingleSlideSwiper
  --------------------------------------------------------- */
  function updateCustomSingleProgress(el, swiper) {
    const section = el.closest('.custom-slide-section');
    const bar = section
      ? section.querySelector('.custom-progress-bar')
      : document.getElementById('customProgressBar');

    if (!bar || !swiper) return;

    const total = swiper.slides ? swiper.slides.length : 0;
    if (!total) return;

    const percent = ((swiper.activeIndex + 1) / total) * 100;
    bar.style.width = percent + '%';
  }

  function initCustomSingleSwipers() {
    document.querySelectorAll('.customSingleSlideSwiper').forEach((el) => {
      if (isInitialized(el)) {
        safeUpdate(el);
        return;
      }

      new Swiper(el, {
        slidesPerView: 1,
        loop: false,
        spaceBetween: 10,
        grabCursor: true,
        allowTouchMove: true,
        observer: true,
        observeParents: true,
        resizeObserver: true,
        on: {
          init(swiper) {
            updateCustomSingleProgress(el, swiper);
          },
          slideChange(swiper) {
            updateCustomSingleProgress(el, swiper);
          }
        }
      });
    });
  }

  /* ---------------------------------------------------------
     4) introSwiper
  --------------------------------------------------------- */
  function updateIntroProgress(el, swiper) {
    const section = el.closest('.intro-slide-section') || el.parentElement?.parentElement;
    const bar = section
      ? section.querySelector('.intro-progress-bar')
      : document.getElementById('introProgressBar');

    if (!bar || !swiper) return;

    const total = swiper.slides ? swiper.slides.length : 0;
    if (!total) return;

    const percent = ((swiper.activeIndex + 1) / total) * 100;
    bar.style.width = percent + '%';
  }

  function initIntroSwipers() {
    document.querySelectorAll('.introSwiper').forEach((el) => {
      if (isInitialized(el)) {
        safeUpdate(el);
        return;
      }

      new Swiper(el, {
        slidesPerView: 1,
        loop: false,
        spaceBetween: 10,
        grabCursor: true,
        allowTouchMove: true,
        observer: true,
        observeParents: true,
        resizeObserver: true,
        on: {
          init(swiper) {
            updateIntroProgress(el, swiper);
          },
          slideChange(swiper) {
            updateIntroProgress(el, swiper);
          }
        }
      });
    });
  }

  /* ---------------------------------------------------------
     5) color_slide_365 (워머 컬러 착용샷)
     - 이 상세는 data-color가 이미 있음
  --------------------------------------------------------- */
  function initColorSlide365Wrap(wrap) {
    const chips = Array.from(wrap.querySelectorAll('.color_slide_365-chip'));
    const sliderEls = Array.from(wrap.querySelectorAll('.color_slide_365-swiper'));
    const progressEls = Array.from(wrap.querySelectorAll('.color_slide_365-progress'));
    const label = wrap.querySelector('.color_slide_365-label');

    if (!chips.length || !sliderEls.length) return;

    function updateProgress(sliderEl, swiper) {
      const color = sliderEl.dataset.color;
      const progress = progressEls.find((el) => {
        if (el.dataset.color) return el.dataset.color === color;
        return el.previousElementSibling === sliderEl;
      });

      const fill = progress?.querySelector('.color_slide_365-progress-fill');
      if (!fill || !swiper) return;

      const total = swiper.slides ? swiper.slides.length : 0;
      if (total <= 1) {
        fill.style.width = '100%';
        return;
      }

      const visible = typeof swiper.params.slidesPerView === 'number'
        ? swiper.params.slidesPerView
        : 1;

      const maxIndex = Math.max(1, Math.ceil(total - visible));
      const current = Math.min(swiper.activeIndex || 0, maxIndex);

      fill.style.width =
        (((current + 1) / (maxIndex + 1)) * 100) + '%';
    }

    function ensureSwiper(sliderEl) {
      if (!sliderEl) return null;

      if (sliderEl.swiper) {
        sliderEl.swiper.update();
        updateProgress(sliderEl, sliderEl.swiper);
        return sliderEl.swiper;
      }

      const instance = new Swiper(sliderEl, {
        slidesPerView: 1.5,
        spaceBetween: 10,
        centeredSlides: false,
        grabCursor: true,
        allowTouchMove: true,
        loop: false,
        observer: true,
        observeParents: true,
        resizeObserver: true,
        on: {
          init(swiper) {
            updateProgress(sliderEl, swiper);
          },
          slideChange(swiper) {
            updateProgress(sliderEl, swiper);
          },
          resize(swiper) {
            updateProgress(sliderEl, swiper);
          }
        }
      });

      updateProgress(sliderEl, instance);
      return instance;
    }

    function showColor(selected) {
      if (!selected) return;

      chips.forEach((chip) => {
        chip.classList.toggle('active', chip.dataset.color === selected);
      });

      sliderEls.forEach((sliderEl) => {
        sliderEl.style.display =
          sliderEl.dataset.color === selected ? 'block' : 'none';
      });

      progressEls.forEach((progressEl, index) => {
        const sliderEl = sliderEls[index];
        const progressColor =
          progressEl.dataset.color || sliderEl?.dataset.color;

        progressEl.style.display =
          progressColor === selected ? 'block' : 'none';
      });

      if (label) label.textContent = selected;

      const target = sliderEls.find(
        (sliderEl) => sliderEl.dataset.color === selected
      );

      if (!target) return;

      requestAnimationFrame(() => {
        const instance = ensureSwiper(target);
        if (!instance) return;

        instance.update();

        if (instance.activeIndex !== 0) {
          instance.slideTo(0, 0);
        }

        updateProgress(target, instance);
      });
    }

    chips.forEach((chip) => {
      if (chip.dataset.detailBoundColor365 === '1') return;
      chip.dataset.detailBoundColor365 = '1';

      chip.addEventListener('click', () => {
        showColor(chip.dataset.color);
      });
    });

    const active =
      chips.find((chip) => chip.classList.contains('active')) ||
      chips[0];

    if (active) showColor(active.dataset.color);
  }

  function initColorSlide365() {
    document.querySelectorAll('.color_slide_365-wrap').forEach((wrap) => {
      initColorSlide365Wrap(wrap);
    });
  }


  /* ---------------------------------------------------------
     6) AIR 메인 히어로 슬라이드
     - .airHeroSwiper
     - 새 테마 DOM 재렌더링 대응
  --------------------------------------------------------- */
  function initAirHeroSwipers() {
    document.querySelectorAll('.airHeroSwiper').forEach((el) => {
      if (isInitialized(el)) {
        safeUpdate(el);
        return;
      }

      const section = el.closest('.airMainSlide') || el.parentElement;
      const paginationEl =
        section?.querySelector('.airHeroPagination') ||
        el.querySelector('.airHeroPagination') ||
        document.querySelector('.airHeroPagination');

      new Swiper(el, {
        slidesPerView: 1,
        loop: true,
        speed: 600,
        grabCursor: true,
        allowTouchMove: true,
        observer: true,
        observeParents: true,
        resizeObserver: true,
        pagination: paginationEl ? {
          el: paginationEl,
          clickable: true
        } : undefined
      });
    });
  }

  /* ---------------------------------------------------------
     7) AIR 사용/활용 슬라이드
     - .airUseSwiper
  --------------------------------------------------------- */
  function initAirUseSwipers() {
    document.querySelectorAll('.airUseSwiper').forEach((el) => {
      if (isInitialized(el)) {
        safeUpdate(el);
        return;
      }

      new Swiper(el, {
        slidesPerView: 1.25,
        spaceBetween: 10,
        grabCursor: true,
        allowTouchMove: true,
        loop: false,
        observer: true,
        observeParents: true,
        resizeObserver: true
      });
    });
  }

  /* ---------------------------------------------------------
     전체 실행
  --------------------------------------------------------- */
  function initAllDetailSwipers() {
    if (!swiperReady()) {
      if (retry++ < MAX_RETRY) {
        setTimeout(initAllDetailSwipers, 100);
      }
      return;
    }

    retry = 0;

    initStructureSwipers();
    bindColorSwiperChips();
    initCustomSingleSwipers();
    initIntroSwipers();
    initColorSlide365();
    initAirHeroSwipers();
    initAirUseSwipers();
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(initAllDetailSwipers, 100);
  }

  function startObserver() {
    if (observer) return;

    observer = new MutationObserver((mutations) => {
      const relevant = mutations.some((mutation) => {
        return Array.from(mutation.addedNodes || []).some((node) => {
          if (!(node instanceof Element)) return false;

          return (
            node.matches?.(
              '.structure-swiper, .colorSwiper, .color-chip, .customSingleSlideSwiper, .introSwiper, .color_slide_365-wrap, .airHeroSwiper, .airUseSwiper'
            ) ||
            node.querySelector?.(
              '.structure-swiper, .colorSwiper, .color-chip, .customSingleSlideSwiper, .introSwiper, .color_slide_365-wrap, .airHeroSwiper, .airUseSwiper'
            )
          );
        });
      });

      if (relevant) schedule();
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  function boot() {
    initAllDetailSwipers();
    startObserver();

    /* 새 테마 상세 DOM 재렌더링 타이밍 대응 */
    setTimeout(initAllDetailSwipers, 250);
    setTimeout(initAllDetailSwipers, 700);
    setTimeout(initAllDetailSwipers, 1500);
    setTimeout(initAllDetailSwipers, 3000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('shopify:section:select', schedule);
  window.addEventListener('pageshow', schedule);
})();


/* =========================================================
   공통 아코디언
   - 새 테마가 상세 DOM을 다시 렌더링해도 작동
   - 개별 .accordion에 직접 이벤트를 묶지 않고 document 이벤트 위임 사용
========================================================= */
(function () {
  if (window.__gooseketAccordionDelegated) return;
  window.__gooseketAccordionDelegated = true;

  document.addEventListener('click', function (event) {
    const accordion = event.target.closest('.accordion');
    if (!accordion) return;

    const panel = accordion.nextElementSibling;
    if (!panel || !panel.classList.contains('panel')) return;

    accordion.classList.toggle('active');

    if (accordion.classList.contains('active')) {
      panel.style.maxHeight = panel.scrollHeight + 'px';
    } else {
      panel.style.maxHeight = null;
    }
  });
})();


/* =========================================================
   공통 상세페이지 비디오 자동재생 복구
   - 새 테마가 상세 DOM을 다시 렌더링해도 다시 play()
   - muted / playsInline 강제
   - 화면에 보이는 비디오 우선 재생
========================================================= */
(function () {
  if (window.__gooseketVideoManager) return;
  window.__gooseketVideoManager = true;

  let videoTimer = null;

  function prepareAndPlay(video) {
    if (!video) return;

    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;

    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');

    if (video.readyState === 0) {
      try { video.load(); } catch (e) {}
    }

    const playPromise = video.play();

    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(() => {});
    }
  }

  function playVisibleVideos() {
    document.querySelectorAll('video').forEach((video) => {
      if (video.offsetParent !== null) {
        prepareAndPlay(video);
      }
    });
  }

  function scheduleVideoPlay() {
    clearTimeout(videoTimer);

    videoTimer = setTimeout(() => {
      playVisibleVideos();
    }, 120);
  }

  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          prepareAndPlay(entry.target);
        }
      });
    }, {
      rootMargin: '200px 0px',
      threshold: 0.01
    });

    function observeVideos() {
      document.querySelectorAll('video').forEach((video) => {
        if (video.dataset.videoObserved === '1') return;
        video.dataset.videoObserved = '1';
        io.observe(video);
      });
    }

    observeVideos();

    const mo = new MutationObserver(() => {
      observeVideos();
      scheduleVideoPlay();
    });

    mo.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleVideoPlay, { once: true });
  } else {
    scheduleVideoPlay();
  }

  window.addEventListener('pageshow', scheduleVideoPlay);
  document.addEventListener('shopify:section:load', scheduleVideoPlay);

  setTimeout(playVisibleVideos, 300);
  setTimeout(playVisibleVideos, 1000);
  setTimeout(playVisibleVideos, 2500);
})();

